import { TextBox, TextBoxTypes } from 'atoms/TextBox'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { LabelGroup } from 'blocks/LabelGroup'
import { Divider } from 'blocks/List/List.h'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { ProgramEpgItemSC } from '../components/ProgramEpgItem.styled'

interface IProgramEpgItemProps {
  labels: string[] | []
  title: string
  subtitle?: string
}

export const ProgramEpgItem = ({
  labels,
  title,
  subtitle,
}: IProgramEpgItemProps) => {
  return (
    <ProgramEpgItemSC>
      <LabelGroup divider={Divider.Dot} columnGap={FIXED_INDENTS.INDENT_40}>
        {Boolean(labels?.length) &&
          labels.map((label) => (
            <TextBox
              title={label}
              font={TextBoxTypes.Caption4}
              color={Colors.TEXT_ICON_SECONDARY}
              key={label}
            />
          ))}
      </LabelGroup>
      <TextBox title={title} font={TextBoxTypes.Footnote5} maxLines={1} />
      <TextBox title={subtitle} font={TextBoxTypes.Caption4} maxLines={1} />
    </ProgramEpgItemSC>
  )
}
